// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2HvYY","disabled":"FileBtn_disabled__3N6Yd","warn":"FileBtn_warn__1Wbp1","fade":"FileBtn_fade__37RBC"};